import React from 'react'
import PropTypes from 'prop-types'
import Select, { components } from 'react-select'
import { createUseStyles } from 'react-jss'

import { theme as localTheme } from '../../theme'
import SVG from '../../SVG/SVG'

const useStyles = createUseStyles(theme => ({
  ageSelect: {
    '& .select__menu': {
      zIndex: 999,
    },
    '& .select__control': {
      border: 'none',
      borderRadius: theme.borderRadius,
      minHeight: 33,
    },
    '& .select__value-container': {
      ...theme.paragraphs.bookingSelectTextStyle,
      cursor: 'pointer',
      color: theme.colors.brushedsteel,
      '& .select__single-value': {
        color: '#424b5a',
        letterSpacing: 0,
      },
    },
    '& .select__dropdown-indicator': {
      padding: 6,
    },
    '& .select__dropdown-indicator svg path': {
      fill: theme.colors.blue,
    },
    '& .select__clear-indicator': {
      padding: 5,
    },
    '& .select__indicators': {
      display: 'none',
    },
    '& .select__option': {
      ...theme.paragraphs.bookingSelectTextStyle,
      border: 'none',
      cursor: 'pointer',
      paddingLeft: 25,
    },
  },
  svgContainer: {
    paddingLeft: 10,
    paddingTop: 4,
    fill: theme.colors.blue,
  },
}))

const colourStyles = {
  control: styles => ({
    ...styles,
    fontSize: 12,
    borderRadius: 17,
    outline: 'none !important',
    boxShadow: '0 !important',
    backgroundColor: 'white',
    letterSpacing: 0,
    '&:hover': {
      border: 'none',
      outline: 'none !important',
    },
    '&:active': {
      border: 'none',
      outline: 'none !important',
    },
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? localTheme.colors.sunflower
        : isFocused
        ? null
        : null,
      color: '#000000',
      cursor: isDisabled ? 'not-allowed' : 'default',
      ':active': {
        ...styles[':active'],
        backgroundColor: localTheme.colors.sunflower,
      },
      ':hover': {
        ...styles[':hover'],
        backgroundColor: localTheme.colors.sunflower,
      },
    }
  },
}

const SVGInContainer = () => {
  const classes = useStyles()
  return (
    <span className={classes.svgContainer}>
      <SVG name="User" width={14.65} height={17.87} />
    </span>
  )
}

const ValueContainer = ({ children, ...props }) => (
  <React.Fragment>
    <components.ValueContainer {...props}>{children}</components.ValueContainer>
  </React.Fragment>
)

// export const AgeSelect = ({ options, isLoading, isDisabled }) => {
export const AgeSelect = props => {
  const classes = useStyles()

  return (
    <React.Fragment>
      <Select
        name={props.name}
        className={classes.ageSelect}
        classNamePrefix="select"
        components={{ ValueContainer }}
        // defaultValue={options[1]}
        isDisabled={props.isDisabled}
        isLoading={props.isLoading}
        isClearable={false}
        isSearchable={false}
        options={props.driveAgeOptions}
        styles={colourStyles}
        value={props.driverAge}
        onChange={props.selectHandleChange}
        onInputChange={props.selectHandleInputChange}
        menuContainerStyle={{ zIndex: 9999999 }}
      />
    </React.Fragment>
  )
}

export default AgeSelect
